import { render, staticRenderFns } from "./AppUserTransactionCounts.vue?vue&type=template&id=317234b4&"
import script from "./AppUserTransactionCounts.vue?vue&type=script&lang=js&"
export * from "./AppUserTransactionCounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports